import { Avatar, IconButton, styled } from '@mui/material';
import { theme } from 'Components/designSystem/theme';
import { MouseEventHandler, useMemo } from 'react';

import { User } from '../../types';

interface UserAvatarCircleProps {
    user: User;
    onClick: MouseEventHandler<HTMLButtonElement>;
}

export default function UserAvatarCircle({ user, onClick }: UserAvatarCircleProps) {
    const backgroundColor = useMemo(() => {
        const backgrounds = theme.userAvatarBackgrounds || [ '#455A64' ];
        const colorKeys = Object.keys(backgrounds);
        const hash = Array.from(user.id).reduce((acc, char) => acc + char.charCodeAt(0), 0);
        const colorKey = colorKeys[hash % colorKeys.length];

        return backgrounds[colorKey];
    }, [ user.id ]);

    const initial = user?.email?.[0]?.toUpperCase() ?? '?';

    return (
        <IconButton onClick={ onClick }>
            <StyledAvatar bgColor={ backgroundColor }>
                { initial }
            </StyledAvatar>
        </IconButton>
    );
}

const StyledAvatar = styled(Avatar, {
    shouldForwardProp: prop => prop !== 'bgColor'
})<{ bgColor: string }>(({ theme, bgColor }) => ({
    width: theme.spacing(8),
    height: theme.spacing(8),
    backgroundColor: bgColor,
    lineHeight: 0
}));
